import React, { useCallback } from 'react';

import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';
import { useCommentService } from '@confluence/content-types-bridge-comments';
import { useCommentsPanelState } from '@confluence/comments-panel-utils/entry-points/useCommentsPanel.ts';
import {
	useIsObjectSidebarShown,
	usePanel,
} from '@confluence/object-sidebar-api/entry-points/useObjectSidebar.ts';
import type { FlagsStateContainer } from '@confluence/flags/entry-points/FlagsStateContainer.ts';
import { CommentNotifications } from '@confluence/quick-reload/entry-points/CommentNotifications.ts';

export function ContentTypeCommentNotifications({
	contentId,
	contentType,
	flags,
}: {
	contentId: string;
	contentType: 'whiteboard' | 'database';
	flags: FlagsStateContainer;
}): React.JSX.Element | null {
	const { userId } = useSessionData();
	const { commentService } = useCommentService();
	const { currentlySelectedThreadKey } = useCommentsPanelState();
	const isSidebarShown = useIsObjectSidebarShown();
	const panel = usePanel();
	const openPanel = useCallback(() => commentService.showPanel(), [commentService]);
	const viewComment = useCallback(
		({ markerRef }: { markerRef?: string }) => {
			commentService.showPanel(markerRef);
			if (markerRef) {
				commentService.handleSelectThread(markerRef);
			}
		},
		[commentService],
	);

	if (!userId) {
		return null;
	}

	return (
		<CommentNotifications
			contentId={contentId}
			contentType={contentType}
			currentAccountId={userId}
			flags={flags}
			selectedThreadKey={
				isSidebarShown && panel?.id === 'commentsPanel' ? currentlySelectedThreadKey : undefined
			}
			onViewComment={viewComment}
			onOpenCommentsPanel={openPanel}
		/>
	);
}
